// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"620eee34","583":"786c6044","845":"e77d0769","983":"cec77b5e"}[chunkId] + ".chunk.js";
};